const Config:any= {
  development: {
		"apipath": "https://qa.stibee.com/api/v1.0",
		"resource": "https://qa-resource.stibee.com",
		"htmlPath": {
			v2: "https://6c87dpndhh.execute-api.ap-northeast-2.amazonaws.com/prod/html",
			v3: "https://6c87dpndhh.execute-api.ap-northeast-2.amazonaws.com/prod/html",
		},
		"unsplashSecret": "RLTalfYY_cHgqL8kqXTfhyWoMnfXJsgbPvRSNR33bVI",
	},
  development_2: {
		"apipath": "https://qa2.stibee.com/api/v1.0",
		"resource": "https://qa-resource.stibee.com",
		"htmlPath": {
			v2: "https://6c87dpndhh.execute-api.ap-northeast-2.amazonaws.com/prod/html",
			v3: "https://6c87dpndhh.execute-api.ap-northeast-2.amazonaws.com/prod/html",
		},
		"unsplashSecret": "RLTalfYY_cHgqL8kqXTfhyWoMnfXJsgbPvRSNR33bVI",
	},
	qa: {
		"apipath": "https://qa.stibee.com/api/v1.0",
		"resource": "https://qa-resource.stibee.com",
		"htmlPath": {
			v2: "https://if08qng5c6.execute-api.ap-northeast-2.amazonaws.com/prod/html",
			v3: "https://6c87dpndhh.execute-api.ap-northeast-2.amazonaws.com/prod/html"
		},
		"unsplashSecret": "RLTalfYY_cHgqL8kqXTfhyWoMnfXJsgbPvRSNR33bVI",
	},
	qa2: {
		"apipath": "https://qa2.stibee.com/api/v1.0",
		"resource": "https://qa-resource.stibee.com",
		"htmlPath": {
			v2: "https://if08qng5c6.execute-api.ap-northeast-2.amazonaws.com/prod/html",
			v3: "https://6c87dpndhh.execute-api.ap-northeast-2.amazonaws.com/prod/html"
		},
		"unsplashSecret": "RLTalfYY_cHgqL8kqXTfhyWoMnfXJsgbPvRSNR33bVI",
	},
	production: {
		"apipath": "https://stibee.com/api/v1.0",
		"resource": "https://resource.stibee.com",
		"htmlPath": {
			v2: "https://htmlv2.stibee.com/prod/html",
			v3: "https://htmlv3.stibee.com/prod/html",
		},
		"unsplashSecret": "RLTalfYY_cHgqL8kqXTfhyWoMnfXJsgbPvRSNR33bVI",
	}
};

export default Config;
